<template>
  <div :style="{width:width+'px',height:height+'px'}">
    <div v-if="design" class="activeMask"/>
    <div style="width: 100%;height: 100%" :id="uuid"/>
  </div>
</template>

<script setup>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty} from "@/utils/refresh-cpt-data";
import {onMounted, watch,computed} from "vue";
import * as echarts from 'echarts'
// import chinaGeoJson from '@/assets/map/china.json'
const loadChinaGeoJson = async () => {
     const { default: chinaGeoJson } = await import('@/assets/map/china.json');
     return chinaGeoJson;
   };

const props = defineProps({
  width:Number,
  height:Number,
  option:Object,
  design:Boolean,
  components:Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
watch(() => props.option.attribute, (obj) => {
    processData(props.option.cptDataForm,newData,jsFunFlag)
  loadChart(obj);
},{deep:true})
watch(() => [props.width,props.height], () => {
  chart.resize()
})
let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])
onMounted(()=>{
  // echarts.registerMap('china', chinaGeoJson);
  // let element = document.getElementById(uuid)
  // if(!element) {
  //   return
  // }
  // chart = echarts.init(element)
  // refreshCptData(props.option.cptDataForm)

  loadChinaGeoJson().then(chinaJson => {
    echarts.registerMap('china', chinaJson);
    let element = document.getElementById(uuid)
    if(!element) {
      return
    }
    chart = echarts.init(element)
    if (dataReload.value.includes(0)) {
      refreshCptData();
    }
  });
})

function refreshCptData(cptDataForm = props.option.cptDataForm,paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm,paras),
  props.components)
}
function loadData(cptDataForm,paras) {
  getDataJson(cptDataForm,paras,(res)=> {
        // cptData = res;
                newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        processData(cptDataForm,newData,jsFunFlag)
        loadChart(props.option.attribute);

      })
}
function processData(cptDataForm,res,jsFunFlag){
          // 第一层判断 如果选择数据集
          if(cptDataForm.dataSource == '4') {
            // 第二层判断 ，如果没有配转换脚本
            if(jsFunFlag) { // 没有全部配置映射字段
                if(hasNonEmptyValues(props.option.attribute.cptTableData)) {
                    const dataKey = props.option.attribute.cptTableData;
                    console.log(res,'res')
                    let newarr = {
  lines: [],
  bars: [],
  mapData: []
};

// 键值映射对象
const dataKeyMap = dataKey.reduce((acc, curr) => {
  acc[curr.namekey] = curr.value;
  return acc;
}, {});

// 遍历 map 数组并填充 newarr
res.forEach(item => {
  const type = item[dataKeyMap.type];
  
  switch (type) {
    case 'line':
      let lineItem = {};
      lineItem.start = item[dataKeyMap.start].split(',').map(Number);
      lineItem.end = item[dataKeyMap.end].split(',').map(Number);
      newarr.lines.push(lineItem);
      break;
    case 'bar':
      let barItem = {};
      barItem.name = item[dataKeyMap.name];
      barItem.lct = item[dataKeyMap.start].split(',').map(Number);
      barItem.value = item[dataKeyMap.value] || null;
      newarr.bars.push(barItem);
      break;
    case 'mapData':
      let mapDataItem = {};
      mapDataItem.name = item[dataKeyMap.name];
      mapDataItem.value = item[dataKeyMap.value] || null;
      newarr.mapData.push(mapDataItem);
      break;
  }
});

console.log(newarr,'新数组')
           cptData = newarr; 
              }
             } else { // 如果配置了转换脚本
             console.log(res,'*')
                cptData = res;
             }
          } else { // 不是数据集类型，是静态数据
            console.log(res,'*')
               cptData = res;
          } 
  }
function loadChart(attr) {
  chart.clear();
  let visualMap = JSON.parse(JSON.stringify(attr.visualMap))
  for (let i = 0; i < visualMap.pieces.length; i++) {
    visualMap.pieces[i].color = attr.color[i]
  }

  let barData = [], linesData = [], scatterData = new Set();
  if(cptData.bars){
    cptData.bars.forEach(bar => {
      barData.push({name:bar.name,value:[bar.lct[0],bar.lct[1],1],num:bar.value})
    })
  }
  if(cptData.lines){
    cptData.lines.forEach(line => {
      linesData.push([line.start,line.end])
      scatterData.add(line.end)//小圆点
    })
  }

  let option = {
    title: attr.title,
    tooltip: {
      trigger: 'item',
      formatter: function(param) {
        if(!param.data){
          return param.name
        }
        return param.data.name+': '+(param.data.num || param.data.value || '')
      }
    },
    geo3D: {
      show: false,
      map: 'china',
      boxHeight: 0.1,
      viewControl: {
        rotateSensitivity:6,//旋转操作的灵敏度
        minBeta:-180,
        maxBeta:180,
        minAlpha:-180,
        maxAlpha:180,
      },
      light: {
        main: {
          alpha: 20,
          beta: -60,
          intensity: 0.8
        },
        ambient: {
          intensity: 0.4
        }
      }
    },
    visualMap: visualMap,
    series:[
      {
        name: '地区',
        zlevel: -20,
        type: 'map3D',
        map: 'china',
        boxHeight: 0.1,
        viewControl: {
          rotateSensitivity:6,
          minBeta:-180,
          maxBeta:180,
          minAlpha:-180,
          maxAlpha:180,
        },
        label: attr.label,
        itemStyle: attr.itemStyle,
        shading:'lambert',
        emphasis:{
          itemStyle:{
            color: '#fed267',
          }
        },
        data: cptData.mapData,
      },
      {
        type: 'lines3D',
        coordinateSystem: 'geo3D',
        animation:true,
        animationDurationUpdate: 6000,
        effect: {
          show: true,
          trailWidth: 2,
          trailColor: attr.line.lineStyle.color,
          trailLength: 0.06,
          trailOpacity: 1,
        },
        lineStyle: attr.line.lineStyle,
        blendMode: 'lighter',
        data: linesData
      },
      {
        type: 'scatter3D',
        coordinateSystem: 'geo3D',
        symbolSize: attr.line.endPoint.symbolSize,
        itemStyle: attr.line.endPoint.itemStyle,
        silent: true,
        data: Array.from(scatterData),
        tooltip: {
          show: false
        }
      },
    ]
  }
  if(barData.length > 0){
    option.series.push({
      type: 'bar3D',
      coordinateSystem: 'geo3D',
      shading: 'lambert',
      // bevelSize:1,
      // bevelSmoothness:20,
      tooltip: {
        show: true,
        type: 'item',
        /*formatter: function(param) {
          return param.data.name+'---: '+(param.data.value[2] || param.data.value)
        }*/
      },
      itemStyle:{
        color: attr.bar.color,
        opacity: 0.8
      },
      emphasis:{
        itemStyle:{
          color:'#fed268'
        }
      },
      minHeight: 8,
      barSize: attr.bar.barSize,
      data: barData,
    })
  }
  chartOption = option
  chart.setOption(chartOption,true);
  chart.on("click", function(params) {
    console.log(params);
  });
}

defineExpose({refreshCptData})
</script>

<style scoped>
.activeMask{width: 100%;height: 100%;position: absolute;z-index: 1801;}
</style>
